import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Globe, Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { images } from '../mockData';

const Navigation = ({ scrollToSection }) => {
  const { language, toggleLanguage, t } = useLanguage();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleNavClick = (id) => {
    scrollToSection(id);
    setMobileMenuOpen(false);
  };

  return (
    <>
      <nav className="nav-header">
        <div className="flex items-center gap-2">
          <img
            src={images.logo}
            alt="Nea Clean Logo"
            className="h-10 w-10 object-cover rounded-full shadow-md" />
          <span className="font-bold text-lg hidden sm:block" style={{ color: 'var(--text-primary)' }}>Nea Clean</span>
        </div>
        
        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-1">
          <button onClick={() => scrollToSection('home')} className="nav-link">{t.nav.home}</button>
          <button onClick={() => scrollToSection('about')} className="nav-link">{t.nav.about}</button>
          <button onClick={() => scrollToSection('services')} className="nav-link">{t.nav.services}</button>
          <button onClick={() => scrollToSection('booking')} className="nav-link">{t.nav.booking}</button>
          <button onClick={() => scrollToSection('reviews')} className="nav-link">{t.nav.reviews}</button>
          <button onClick={() => scrollToSection('contact')} className="nav-link">{t.nav.contact}</button>
        </div>

        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            size="lg"
            onClick={toggleLanguage}
            className="rounded-full px-4 py-2 text-sm font-semibold"
            style={{ 
              background: 'linear-gradient(135deg, #FFB6C1 0%, #FFC0CB 100%)',
              color: 'white'
            }}>
            <Globe className="w-4 h-4 mr-1" />
            {language === 'en' ? 'Ελληνικά' : 'English'}
          </Button>
          
          {/* Desktop Book Now Button */}
          <Button
            onClick={() => scrollToSection('booking')}
            className="items-center justify-center whitespace-nowrap transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 hover:bg-primary/90 h-9 btn-primary hidden md:inline-flex !font-medium !text-sm gap-2 px-4 py-2 !rounded-[20px] shadow text-primary-foreground bg-primary">
            {t.nav.booking}
          </Button>

          {/* Mobile Hamburger Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6" style={{ color: 'var(--text-primary)' }} />
            ) : (
              <Menu className="w-6 h-6" style={{ color: 'var(--text-primary)' }} />
            )}
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {mobileMenuOpen && (
        <div className="md:hidden fixed inset-0 z-40 bg-white shadow-lg" style={{ top: '60px' }}>
          <div className="flex flex-col p-4 space-y-2">
            <button 
              onClick={() => handleNavClick('home')} 
              className="text-left py-3 px-4 rounded-lg hover:bg-sky-50 transition-colors font-medium"
              style={{ color: 'var(--text-primary)' }}
            >
              {t.nav.home}
            </button>
            <button 
              onClick={() => handleNavClick('about')} 
              className="text-left py-3 px-4 rounded-lg hover:bg-sky-50 transition-colors font-medium"
              style={{ color: 'var(--text-primary)' }}
            >
              {t.nav.about}
            </button>
            <button 
              onClick={() => handleNavClick('services')} 
              className="text-left py-3 px-4 rounded-lg hover:bg-sky-50 transition-colors font-medium"
              style={{ color: 'var(--text-primary)' }}
            >
              {t.nav.services}
            </button>
            <button 
              onClick={() => handleNavClick('booking')} 
              className="text-left py-3 px-4 rounded-lg hover:bg-sky-50 transition-colors font-medium"
              style={{ color: 'var(--text-primary)' }}
            >
              {t.nav.booking}
            </button>
            <button 
              onClick={() => handleNavClick('reviews')} 
              className="text-left py-3 px-4 rounded-lg hover:bg-sky-50 transition-colors font-medium"
              style={{ color: 'var(--text-primary)' }}
            >
              {t.nav.reviews}
            </button>
            <button 
              onClick={() => handleNavClick('contact')} 
              className="text-left py-3 px-4 rounded-lg hover:bg-sky-50 transition-colors font-medium"
              style={{ color: 'var(--text-primary)' }}
            >
              {t.nav.contact}
            </button>
            <div className="pt-4">
              <Button
                onClick={() => handleNavClick('booking')}
                className="w-full btn-primary h-12 text-base font-semibold"
              >
                {t.nav.booking}
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navigation;